<div>
    <div>
        <app-header></app-header>
    </div>
    <div>
        <router-outlet></router-outlet>
    </div>
    <div style="
    padding: 0.1rem;
    bottom: 0;
    width: 100%;
    height: 3rem;
    box-shadow: 0px 0px 4px gray;
    position: fixed;
    z-index: 999;
    background-color: white;">
        <app-footer></app-footer>
    </div>
</div>